import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppointmentBookingContainer } from '@app/my-zone/shared/appointment/appointment-booking/appointment-booking.container';
import { LocationsFormComponent } from '@app/my-zone/shared/appointment/appointment-booking/locations-form/locations-form.component';
import { AppointmentConfirmationModalModule } from '@app/my-zone/shared/appointment/appointment-confirmation-modal';
import { AppointmentContainer } from '@app/my-zone/shared/appointment/appointment.container';
import { CynoDatepickerInputModule } from '@app/shared/cyno-form/cyno-datepicker/cyno-datepicker.module';
import { CynoFormModule } from '@app/shared/cyno-form/cyno-form.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { UtilitiesModule } from '@app/shared/utilities/utilities.module';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { OutContentModule } from 'outshared-lib';
import { AppointmentBookingComponent } from './appointment-booking/appointment-booking.component';
import { DateFormComponent } from './appointment-booking/date-form/date-form.component';
import { TimeslotFormComponent } from './appointment-booking/timeslot-form/timeslot-form.component';
import { AppointmentOverviewComponent } from './appointment-overview/appointment-overview.component';
import { AppointmentComponent } from './appointment.component';
import { AppointmentService } from './appointment.service';

@NgModule({
    declarations: [
        AppointmentComponent,
        AppointmentBookingComponent,
        AppointmentOverviewComponent,
        LocationsFormComponent,
        DateFormComponent,
        TimeslotFormComponent,
        AppointmentContainer,
        AppointmentBookingContainer,
    ],
    imports: [
        OutContentModule,
        CommonModule,
        PipesModule,
        LazyLoadImageModule,
        UtilitiesModule,
        CynoFormModule,
        ListModule,
        AppointmentConfirmationModalModule,
        CynoDatepickerInputModule,
    ],
    exports: [
        AppointmentContainer,
    ],
    providers: [
        AppointmentService,
    ],
})
export class AppointmentModule {
}
